export const ReportItemProgress = {
  Completed: 'Completed',
  InProgress: 'In progress',
  Incomplete: 'Incomplete',
};
